export const BEPContractAddress = "0x8083f306F987fd6965b1Cec9EaFc4e7Ac64B6c5c";